export default __webpack_public_path__ + "static/media/el10.f9dd3aef.svg";